import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function SingleChoice({
  question,
  choices,
  qKey,
  onSubmitHandler,
  selectedChoice = null,
}) {
  const [currentChoice, setChoice] = useState(
    selectedChoice || { value: null, text: null }
  );
  const [options, _] = useState(choices || []);
  const handleChange = (choice) => setChoice(choice);
  const { t } = useTranslation();

  useEffect(() => {
    if (options) {
      const defaultClinic = options.find(
        (choice) => choice.value === "CC000001"
      );
      if (defaultClinic) {
        // setChoice(defaultClinic);
      }
    }
  }, [options]);

  const Choices = choices.map((choice, index) => {
    return (
      <li key={index}>
        <label>
          <input
            type="radio"
            name={qKey}
            value={choice.value}
            checked={currentChoice.value === choice.value}
            onChange={() => handleChange(choice)}
            disabled={
              choice.hasOwnProperty("disabled") ? choice.disabled : false
            }
          />
          <span className="dot"></span>
          <span
            className={
              choice.hasOwnProperty("disabled") && choice.disabled
                ? "txt disabled-txt"
                : "txt"
            }
          >
            {choice.text}
          </span>
        </label>
      </li>
    );
  });

  return (
    <div className="body_content">
      <div className="inner_body ">
        <h3 className="headtitle">{question}</h3>
        <ul className="list-unstyled list_radio_btn">{Choices}</ul>
        <div className="btn_block bottom_button d-flex justify-content-center">
          <button
            className="btn btn_primary nextstep_cta"
            disabled={currentChoice.value == null}
            onClick={() => onSubmitHandler(currentChoice)}
          >
            {t("login.DOBSTEP.button")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SingleChoice;
